import { Features } from '@/types'
import type { PlanFeatures } from '@/types/plans'

/**
 * The following info are used to display the plans details in upgrading/downgrading modals
 * for the new pricing plans 2025.
 * @todo: these info should be fetched from a trusted external source and not be harcoded here
 */
export const defaultFeatures: PlanFeatures[] = [
  {
    label: 'Activity Log',
    value: Features.Activity,
  },
  {
    label: 'Asset Manager',
    value: Features.Assets,
  },
  {
    label: 'Asset Folders',
    value: Features.AssetFolders,
  },
  {
    label: 'Autosave',
    value: Features.AutoSave,
  },
  {
    label: 'Clipboard History',
    value: Features.ClipboardHistory,
  },
  {
    label: 'Clone Projects',
    value: Features.CloneProjects,
  },
  {
    label: 'Custom Field Types',
    value: Features.CustomFieldTypes,
  },
  {
    label: 'Datasources',
    value: Features.Datasources,
  },
  {
    label: 'Image Optimization Service',
    value: Features.ImageOptimization,
  },
  {
    label: 'Responsive Preview',
    value: Features.ResponsivePreview,
  },
  {
    label: 'Standard Workflows',
    value: Features.Workflows,
  },
  {
    label: 'Documentation',
    value: Features.Docs,
  },
  {
    label: 'Locales',
    value: Features.Locales,
  },
  {
    label: 'Webhooks',
    value: Features.WebHooks,
  },
  {
    label: 'Visual Editor',
    value: Features.VisualEditor,
  },
  {
    label: '2 Factor Authentication (2FA)',
    value: Features['2FA'],
  },
]

export const growthFeatures: PlanFeatures[] = [
  ...defaultFeatures,
  // difference between starter and growth features starts here
  {
    label: 'Content Locking App',
    value: Features.ContentLocking,
  },
  {
    label: 'Dimensions',
    value: Features.Dimensions,
  },
  {
    label: 'Replace Assets App',
    value: Features.ReplaceAsset,
  },
  {
    label: 'SEO Meta Tags App',
    value: Features.SEOMetaTags,
  },
  {
    label: 'Task-Manager App',
    value: Features.TaskManager,
  },
  {
    label: 'Translatable Slugs App',
    value: Features.TranslatableSlugs,
  },
  {
    label: 'Webhook Secrets',
    value: Features.WebHookSecrets,
  },
  {
    label: 'Integration to Cloudinary Asset Manager',
    value: Features.Cloudinary,
  },
  {
    label: 'Integration to Optimizely',
    value: Features.Optimizely,
  },
  {
    label: 'Integration to Shopify',
    value: Features.Shopify,
  },
]

export const growthPlusFeatures: PlanFeatures[] = [
  ...growthFeatures,
  // difference between growth and growth plus features starts here
  {
    label: 'Assets Additional Usage',
    value: Features.HasAdditionalUsageAssets,
  },
  {
    label: 'Stories Additional Usage',
    value: Features.HasAdditionalUsageAssets,
  },
]
